import React from 'react';
import BaseTooltip from './BaseTooltip';
import {TooltipPlacement} from './types';

interface TooltipProps {
  content: React.ReactNode;
  placement?: TooltipPlacement;
  children: React.ReactElement;
  disabled?: boolean;
  delay?: number;
  className?: string;
  zIndex?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
    content,
    placement = 'top',
    children,
    disabled = false,
    delay = 0,
    className = '',
    zIndex = 9999,
}) => {
    return (
        <BaseTooltip
            content={content}
            placement={placement}
            disabled={disabled}
            delay={delay}
            className={`unified-tooltip--simple ${className}`}
            trigger="hover"
            arrow={true}
            interactive={false}
            zIndex={zIndex}
        >
            {children}
        </BaseTooltip>
    );
};

export default Tooltip;
